import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axiosClient';
import ServicesSelect from './ServicesSelect';
import Cookies from 'js-cookie';
import { CHERNI_VRAH_ID, LOCATIONS } from '../data/locations';
import { isOwner as getIsOwner } from '../api/auth';
import emoImage from '../images/emo.png';
import bobiImage from '../images/bobi.png';
import marioImage from '../images/mario.png';
import sotirImage from '../images/sotir.jpg';
import georgiImage from '../images/georgi.png';

// Снимка на бръснаря по име, както го връща API-то (id-тата на новите
// бръснари се дават от базата, затова не са надежден ключ).
const BARBER_IMAGES = {
  'Емил': emoImage,
  'Боян': bobiImage,
  'Марио': marioImage,
  'Сотир': sotirImage,
  'Георги': georgiImage,
};

// Vacation mode toggle - set to true to enable vacation mode
const VACATION_MODE = false;

function customSmoothScrollToElement(element, duration = 800) {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const startY = window.pageYOffset;
  const elementY = element.getBoundingClientRect().top + startY;
  const targetY = elementY - (window.innerHeight / 2 - element.offsetHeight / 2);

  if (!isSafari && 'scrollBehavior' in document.documentElement.style) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  const startTime = Date.now();

  const animateScroll = () => {
    const currentTime = Date.now();
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const ease = progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;

    window.scrollTo(0, startY + (targetY - startY) * ease);

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    }
  };

  requestAnimationFrame(animateScroll);
}

const getFormattedDate = (dateObj) => {
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const year = dateObj.getFullYear();
  return `${year}-${month}-${day}`;
};

const parseLocalDateString = (dateString) => {
  if (!dateString) return null;
  const [year, month, day] = dateString.split('-').map(Number);
  if (
    Number.isNaN(year) ||
    Number.isNaN(month) ||
    Number.isNaN(day)
  ) {
    return null;
  }
  return new Date(year, month - 1, day);
};

// Работното време на салоните е до 19:00 — след този час предлагаме утрешна дата.
const getDefaultDate = () => {
  const now = new Date();
  if (now.getHours() >= 19) {
    now.setDate(now.getDate() + 1)
  }
  return getFormattedDate(now);
};

const timeToMinutes = (time) => {
  if (!time) return null;
  const [hours, minutes] = time.split(':').map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  return hours * 60 + minutes;
};

const minutesToTime = (totalMinutes) => {
  const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
  const minutes = String(totalMinutes % 60).padStart(2, '0');
  return `${hours}:${minutes}`;
};

// Редът от графика на бръснаря за деня от седмицата на дадена дата
// (schedules идват от GET /api/barbers). null = почивен ден.
const getScheduleFor = (barber, dateString) => {
  const date = parseLocalDateString(dateString);
  if (!date || !Array.isArray(barber?.schedules)) return null;
  return barber.schedules.find((s) => s.dayOfWeek === date.getDay()) || null;
};

const isVacationMode = () => {
  if (!VACATION_MODE) return false;

  const today = new Date();
  const vacationEndDate = new Date("2025-09-04");

  return today <= vacationEndDate;
};


const getVacationEndDate = () => {
const vacationEndDate = new Date("2025-09-04");

  const day = vacationEndDate.getDate();
  const month = vacationEndDate.getMonth() + 1;

  // Bulgarian ordinal suffixes
  const getOrdinalSuffix = (day) => {
    if (day === 1 || day === 21 || day === 31) return 'ви';
    if (day === 2 || day === 22) return 'ри';
    if (day === 3 || day === 23) return 'ти';
    return 'ти';
  };

  const monthNames = [
    'януари', 'февруари', 'март', 'април', 'май', 'юни',
    'юли', 'август', 'септември', 'октомври', 'ноември', 'декември'
  ];

  return `${day}${getOrdinalSuffix(day)} ${monthNames[month - 1]}`;
};

function BarberShopReservation({ locationId }) {
  const [barbers, setBarbers] = useState([]);
  const [sortedBarbers, setSortedBarbers] = useState([]);
  const [selectedStylist, setSelectedStylist] = useState('');
  const [selectedDate, setSelectedDate] = useState(getDefaultDate());
  const [selectedTime, setSelectedTime] = useState('');
  const [selectedService, setSelectedService] = useState('');
  const [message, setMessage] = useState('');
  const [timeSlots, setTimeSlots] = useState([]);
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [services, setServices] = useState([]);
  const [servicesLoading, setServicesLoading] = useState(false);
  const [servicesError, setServicesError] = useState(null);
  const [reservations, setReservations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentReservation, setCurrentReservation] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationModalMessage, setConfirmationModalMessage] = useState('');
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [blockMode, setBlockMode] = useState('slots');
  const [blockDate, setBlockDate] = useState(getDefaultDate());
  const [blockSlots, setBlockSlots] = useState([]);
  const [blockSelectedSlots, setBlockSelectedSlots] = useState([]);
  const [blockDates, setBlockDates] = useState([]);
  const [blockDateInput, setBlockDateInput] = useState(getDefaultDate());
  const [blockLoading, setBlockLoading] = useState(false);
  const [blockSlotsLoading, setBlockSlotsLoading] = useState(false);
  const [blockError, setBlockError] = useState('');
  const [blockSuccessMessage, setBlockSuccessMessage] = useState('');

  const isAuthenticated = !!Cookies.get('isAuthenticated');
  // Блокиране и изтриване — само за собственика; бръснарите (Staff) само записват.
  const isOwner = isAuthenticated && getIsOwner();
  const navigate = useNavigate();

  const getAuthHeaders = useCallback(() => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }, []);

  const handleUnauthorized = useCallback(() => {
    Cookies.remove('isAuthenticated');
    localStorage.removeItem('token');
    navigate('/login');
  }, [navigate]);

  const selectedStylistComparable = useMemo(() => {
    if (selectedStylist === null || selectedStylist === undefined) {
      return '';
    }
    return String(selectedStylist);
  }, [selectedStylist]);
  const selectedBarber = useMemo(
    () => barbers.find((barber) => String(barber.id) === selectedStylistComparable),
    [barbers, selectedStylistComparable]
  );

  // Бръснарите, които работят на тази локация в избраната дата.
  const workingBarbers = useMemo(
    () =>
      barbers.filter((barber) => {
        const schedule = getScheduleFor(barber, selectedDate);
        return schedule && schedule.locationId === locationId;
      }),
    [barbers, locationId, selectedDate]
  );

  const selectedSchedule = useMemo(
    () => (selectedBarber ? getScheduleFor(selectedBarber, selectedDate) : null),
    [selectedBarber, selectedDate]
  );

  // Обедна почивка на избрания бръснар за избрания ден ('' = няма).
  const lunchBreakNote = useMemo(() => {
    const { breakStart, breakEnd } = selectedSchedule || {};
    if (!breakStart || !breakEnd) return '';
    return `Обедна почивка ${breakStart}–${breakEnd} ч.`;
  }, [selectedSchedule]);

  const isClosedForSelectedDate = workingBarbers.length === 0;
  const selectedDateIsSunday = useMemo(() => {
    const date = parseLocalDateString(selectedDate);
    return date ? date.getDay() === 0 : false;
  }, [selectedDate]);

  useEffect(() => {
    const maybeUpdateDate = () => {
      const defaultDate = getDefaultDate();
      setSelectedDate((prev) => {
        if (!prev) return defaultDate;
        return prev < defaultDate ? defaultDate : prev;
      });
    };

    maybeUpdateDate();

    const intervalId = setInterval(maybeUpdateDate, 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  // Смяна на локацията: часът и съобщенията се нулират.
  useEffect(() => {
    setSelectedTime('');
    setMessage('');
    setCurrentReservation(null);
  }, [locationId]);

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        const modalElement = document.getElementById('admin-modal');
        if (modalElement) {
          requestAnimationFrame(() => {
            customSmoothScrollToElement(modalElement);
          });
        }
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [showModal]);

  useEffect(() => {
    if (showConfirmationModal) {
      const timer = setTimeout(() => {
        const modalElement = document.getElementById('confirmation-modal');
        if (modalElement) {
          requestAnimationFrame(() => {
            customSmoothScrollToElement(modalElement);
          });
        }
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [showConfirmationModal]);


  useEffect(() => {
    const fetchBarbers = async () => {
      try {
        const response = await axios.get('/api/barbers');
        setBarbers(response.data);
      } catch (err) {
        console.error('Failed to load barbers', err);
      }
    };

    fetchBarbers();
  }, []);

  // Услугите с точните цени за избраните бръснар + локация.
  useEffect(() => {
    if (!locationId || !selectedStylistComparable) {
      setServices([]);
      return;
    }

    let cancelled = false;
    const fetchServices = async () => {
      setServicesLoading(true);
      setServicesError(null);
      try {
        const response = await axios.get(
          `/api/services?locationId=${locationId}&barberId=${selectedStylistComparable}`
        );
        if (cancelled) return;
        const list = response.data || [];
        setServices(list);
        // Каталогът се сменя с бръснаря/локацията — избраната услуга
        // трябва да съществува в новия списък.
        setSelectedService((prev) => {
          if (prev && list.some((s) => String(s.id) === String(prev))) {
            return prev;
          }
          return list[0]?.id ?? '';
        });
      } catch (err) {
        if (cancelled) return;
        console.error('Failed to load services', err);
        setServicesError('Грешка при зареждането на услугите');
      } finally {
        if (!cancelled) {
          setServicesLoading(false);
        }
      }
    };

    fetchServices();
    return () => {
      cancelled = true;
    };
  }, [locationId, selectedStylistComparable]);

  const serviceDuration = useMemo(() => {
    const service = services.find((s) => String(s.id) === String(selectedService));
    return service?.duration || 30;
  }, [services, selectedService]);

  const blockService = useMemo(() => {
    if (!services || services.length === 0) return null;
    const normalize = (value) => (value || '').toString().toLowerCase();
    return (
      services.find((service) => {
        const name = normalize(service.name);
        return (
          name.includes('подстриг') ||
          name.includes('haircut') ||
          name.includes('мъжко подстригване')
        );
      }) || services[0]
    );
  }, [services]);
  const blockServiceDuration = useMemo(
    () => blockService?.duration || 30,
    [blockService]
  );

  useEffect(() => {
    setSelectedTime('');
  }, [selectedService]);

  // Слотове по 30 мин от графика на бръснаря за датата (напр. Георги: 14:30–19:00).
  // Слотовете в обедната почивка остават в масива, но са заети: проверките за
  // услуги над 30 мин броят съседни индекси и разчитат редицата да е непрекъсната.
  const generateTimeSlotsForBarber = useCallback(
    (barberId, dateString = selectedDate) => {
      const barber = barbers.find((b) => String(b.id) === String(barberId));
      const schedule = barber ? getScheduleFor(barber, dateString) : null;
      if (!schedule) return [];

      const start = timeToMinutes(schedule.start);
      const end = timeToMinutes(schedule.end);
      if (start === null || end === null) return [];

      const breakStart = timeToMinutes(schedule.breakStart);
      const breakEnd = timeToMinutes(schedule.breakEnd);
      const hasBreak = breakStart !== null && breakEnd !== null && breakEnd > breakStart;

      const slots = [];
      for (let current = start; current < end; current += 30) {
        const isBreak = hasBreak && current < breakEnd && current + 30 > breakStart;
        slots.push({ time: minutesToTime(current), available: !isBreak, isBreak });
      }
      return slots;
    },
    [barbers, selectedDate]
  );

  const fetchSlotsForBarberOnDate = useCallback(async (date, barberId) => {
    const slots = generateTimeSlotsForBarber(barberId, date).map((slot) => ({ ...slot }));
    if (!date || !barberId || slots.length === 0) {
      return slots;
    }

    try {
      const response = await axios.get(
        `/api/reservations?barberId=${barberId}&date=${date}`
      );
      const reservationsForDate = response.data.filter((reservation) => {
        const reservationDate = new Date(reservation.reservationDateTime).toISOString().split('T')[0];
        return (
          reservationDate === date &&
          String(reservation.barberId) === String(barberId)
        );
      });

      reservationsForDate.forEach((reservation) => {
        const reservationDate = new Date(reservation.reservationDateTime);
        const reservationTime = reservationDate.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        });

        const startTimeIndex = slots.findIndex((slot) => slot.time === reservationTime);

        if (startTimeIndex !== -1) {
          const numSlotsRequired =
            reservation.service && reservation.service.duration
              ? reservation.service.duration / 30
              : 1;
          for (let i = 0; i < numSlotsRequired; i++) {
            const slotToCheck = slots[startTimeIndex + i];
            if (slotToCheck) {
              slotToCheck.available = false;
            }
          }
        }
      });

      return slots;
    } catch (error) {
      console.error('Failed to load slots for blocking:', error);
      throw error;
    }
  }, [generateTimeSlotsForBarber]);

  const updateTimeSlots = useCallback(
    (reservations, serviceDurationValue) => {
      const generatedSlots = generateTimeSlotsForBarber(selectedStylistComparable);
    const updatedSlots = generatedSlots.map((slot, index, slots) => {
      let isTaken = false;

      reservations
        .filter(
          (x) =>
            String(x.barberId) === selectedStylistComparable &&
            new Date(x.reservationDateTime).toISOString().split('T')[0] === selectedDate
        )
        .forEach((reservation) => {
          const reservationDate = new Date(reservation.reservationDateTime);
          const reservationDuration = reservation.service.duration;

          const reservationTime = reservationDate.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          });

          const startTimeIndex = slots.findIndex((s) => s.time === reservationTime);

          if (startTimeIndex !== -1) {
            const numSlotsRequired = reservationDuration / 30;
            for (let i = 0; i < numSlotsRequired; i++) {
              const slotToCheck = slots[startTimeIndex + i];
              if (slotToCheck) {
                slotToCheck.available = false;
              }
            }
          }
        });

      if (!isTaken && serviceDurationValue > 30) {
        const numSlotsRequiredForService = serviceDurationValue / 30;
        for (let i = 0; i < numSlotsRequiredForService; i++) {
          const nextSlot = slots[index + i];
          if (!nextSlot || !nextSlot.available) {
            isTaken = true;
            break;
          }
        }
      }

      if (!slot.available) {
        isTaken = true;
      }

      return { ...slot, available: !isTaken };
    });

      setTimeSlots(updatedSlots);
    },
    [generateTimeSlotsForBarber, selectedDate, selectedStylistComparable]
  );

  const fetchReservations = useCallback(async () => {
    if (!selectedStylistComparable || !selectedDate) {
      return;
    }

      try {
      const reservationsResponse = await axios.get(
        `/api/reservations?barberId=${selectedStylistComparable}&date=${selectedDate}`,
        isAuthenticated ? { headers: getAuthHeaders() } : {}
        );
      const reservationsData = reservationsResponse.data;
      setReservations(reservationsData);
      updateTimeSlots(reservationsData, serviceDuration);
      } catch (err) {
        if (err.response?.status === 401) {
          handleUnauthorized();
          return;
        }
        console.error('Failed to fetch reservations', err);
      }
  }, [getAuthHeaders, handleUnauthorized, isAuthenticated, selectedDate, selectedStylistComparable, serviceDuration, updateTimeSlots]);

  useEffect(() => {
    if (!selectedDate || !selectedSchedule) {
      setTimeSlots([]);
      return;
    }

    fetchReservations();
  }, [fetchReservations, selectedDate, selectedSchedule]);

  useEffect(() => {
    if (!reservations.length || !selectedSchedule) {
      return;
    }
    updateTimeSlots(reservations, serviceDuration);
  }, [reservations, serviceDuration, updateTimeSlots, selectedSchedule]);

  // Подрежда работещите бръснари по дял свободни часове и поддържа валиден избор.
  useEffect(() => {
    const sortBarbersByAvailableSlots = async () => {
      if (!selectedDate || barbers.length === 0) return;

      if (workingBarbers.length === 0) {
        setSortedBarbers([]);
        return;
      }

      try {
        const res = await axios.get(
          `/api/reservations?date=${selectedDate}`
        );
        const reservationsForDay = res.data.filter((reservation) => {
          const reservationDate = new Date(reservation.reservationDateTime)
            .toISOString()
            .split('T')[0];
          return reservationDate === selectedDate;
        });

        // Свободните часове като ДЯЛ от смяната, не като абсолютен брой: иначе
        // по-дългата смяна печели и когато е по-заета. Георги работи 14:30–19:00
        // (9 часа за резервация), Сотир 10:00–19:00 (16) — празен Георги оставаше
        // след Сотир, докато Сотир не запълни над 7 часа.
        const getAvailabilityForBarber = (barberId) => {
          const slots = generateTimeSlotsForBarber(barberId).map((slot) => ({ ...slot }));
          // Обедната почивка не е час, зает от клиент — вън от знаменателя.
          const bookable = slots.filter((slot) => slot.available).length;
          if (bookable === 0) return { free: 0, bookable: 0 };

          // Блокираните часове също заемат слот — както в самата мрежа.
          reservationsForDay
            .filter((reservation) => String(reservation.barberId) === String(barberId))
            .forEach((reservation) => {
              const reservationDate = new Date(reservation.reservationDateTime);
              const reservationTime = reservationDate.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              });
              const startIndex = slots.findIndex((slot) => slot.time === reservationTime);
              if (startIndex !== -1) {
                const slotsNeeded = reservation.service?.duration
                  ? reservation.service.duration / 30
                  : 1;
                for (let i = 0; i < slotsNeeded; i++) {
                  if (startIndex + i < slots.length) {
                    slots[startIndex + i].available = false;
                  }
                }
              }
            });

          return { free: slots.filter((slot) => slot.available).length, bookable };
        };

        const availability = new Map(
          workingBarbers.map((barber) => [String(barber.id), getAvailabilityForBarber(barber.id)])
        );

        const sorted = [...workingBarbers].sort((a, b) => {
          const x = availability.get(String(a.id));
          const y = availability.get(String(b.id));
          // Дяловете, сравнени с умножение на кръст — цели числа, без плаваща запетая.
          const byShare = y.free * x.bookable - x.free * y.bookable;
          if (byShare !== 0) return byShare;
          // Равен дял: първи е този с повече свободни часове (по-дългата смяна).
          return y.free - x.free;
        });

        setSortedBarbers(sorted);
        if (sorted.length > 0) {
          const selectedExists = sorted.some(
            (barber) => String(barber.id) === selectedStylistComparable
          );
          if (!selectedExists) {
            setSelectedStylist(String(sorted[0].id));
          }
        }
      } catch (error) {
        console.error('Error sorting barbers by available slots:', error);
        setSortedBarbers(workingBarbers);
        if (
          workingBarbers.length > 0 &&
          !workingBarbers.some((barber) => String(barber.id) === selectedStylistComparable)
        ) {
          setSelectedStylist(String(workingBarbers[0].id));
        }
      }
    };

    sortBarbersByAvailableSlots();
  }, [barbers, generateTimeSlotsForBarber, selectedDate, selectedStylistComparable, workingBarbers]);

  const openBlockModal = () => {
    const initialDate = selectedDate || getDefaultDate();
    setBlockMode('slots');
    setBlockDate(initialDate);
    setBlockDateInput(initialDate);
    setBlockSelectedSlots([]);
    setBlockDates([]);
    setBlockError('');
    setBlockSuccessMessage('');
    setShowBlockModal(true);
  };

  const closeBlockModal = () => {
    setShowBlockModal(false);
    setBlockSelectedSlots([]);
    setBlockDates([]);
    setBlockLoading(false);
    setBlockSlotsLoading(false);
    setBlockError('');
    setBlockSuccessMessage('');
  };

  const handleToggleBlockSlot = (time) => {
    setBlockSelectedSlots((prev) => {
      if (prev.includes(time)) {
        return prev.filter((slotTime) => slotTime !== time);
      }
      return [...prev, time].sort();
    });
  };

  const handleAddBlockDate = () => {
    if (!blockDateInput) {
      return;
    }
    setBlockDates((prev) => {
      if (prev.includes(blockDateInput)) {
        return prev;
      }
      return [...prev, blockDateInput].sort();
    });
  };

  const handleRemoveBlockDate = (dateToRemove) => {
    setBlockDates((prev) => prev.filter((date) => date !== dateToRemove));
  };

  const createBlockReservation = async (date, time, barberId) => {
    // Блокирането важи за локацията, на която бръснарят работи този ден.
    const barber = barbers.find((b) => String(b.id) === String(barberId));
    const scheduleForDate = barber ? getScheduleFor(barber, date) : null;

    const reservationData = {
      customerName: 'Blocked',
      phoneNumber: 'blocked',
      email: 'blocked@blocked.blocked',
      reservationDateTime: `${date}T${time}:00`,
      serviceId: blockService.id,
      barberId,
      locationId: scheduleForDate?.locationId ?? locationId,
      isBlock: true,
    };

    await axios.post('/api/reservations', reservationData, {
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    });
  };

  const handleBlockSubmit = async () => {
    setBlockError('');
    setBlockSuccessMessage('');

    if (!isOwner) {
      setBlockError('Само администратори могат да блокират графика.');
      return;
    }

    if (!selectedStylist) {
      setBlockError('Моля, изберете бръснар, преди да блокирате график.');
      return;
    }

    if (!blockService) {
      setBlockError('Не е намерена услуга за блокиране. Моля, уверете се, че услугата "Подстригване" е налична.');
      return;
    }

    const barberId = selectedStylist;

    try {
      setBlockLoading(true);

      if (blockMode === 'slots') {
        if (!blockDate || blockSelectedSlots.length === 0) {
          setBlockError('Изберете дата и поне един час за блокиране.');
          setBlockLoading(false);
          return;
        }

        const sortedSlots = [...blockSelectedSlots].sort();
        for (const time of sortedSlots) {
          await createBlockReservation(blockDate, time, barberId);
        }

        const updatedSlots = await fetchSlotsForBarberOnDate(blockDate, barberId);
        setBlockSlots(updatedSlots);
        setBlockSelectedSlots([]);
        setBlockSuccessMessage('Успешно блокирахте избраните часове.');
      } else {
        if (blockDates.length === 0) {
          setBlockError('Добавете поне една дата за блокиране.');
          setBlockLoading(false);
          return;
        }

        const orderedDates = [...new Set(blockDates)].sort();
        const slotsPerReservation = Math.max(1, blockServiceDuration / 30);

        for (const date of orderedDates) {
          const daySlots = await fetchSlotsForBarberOnDate(date, barberId);

          for (let i = 0; i < daySlots.length; i++) {
            const slot = daySlots[i];
            if (!slot.available) {
              continue;
            }

            let canBlock = true;
            for (let j = 0; j < slotsPerReservation; j++) {
              const consecutiveSlot = daySlots[i + j];
              if (!consecutiveSlot || !consecutiveSlot.available) {
                canBlock = false;
                break;
              }
            }

            if (!canBlock) {
              continue;
            }

            await createBlockReservation(date, slot.time, barberId);

            for (let j = 0; j < slotsPerReservation; j++) {
              if (daySlots[i + j]) {
                daySlots[i + j].available = false;
              }
            }
          }
        }

        setBlockDates([]);
        setBlockSuccessMessage('Успешно блокирахте избраните дни.');
      }

      await fetchReservations();
    } catch (error) {
      if (error.response?.status === 401) {
        handleUnauthorized();
        return;
      }
      console.error('Failed to block schedule:', error.response?.data || error.message);
      setBlockError('Възникна грешка при блокирането. Моля, опитайте отново.');
    } finally {
      setBlockLoading(false);
    }
  };

  useEffect(() => {
    if (!showBlockModal || blockMode !== 'slots' || !selectedStylistComparable || !blockDate) {
      return;
    }

    const loadSlotsForBlocking = async () => {
      setBlockSlotsLoading(true);
      setBlockError('');
      try {
        const slots = await fetchSlotsForBarberOnDate(blockDate, selectedStylist);
        setBlockSlots(slots);
      } catch (error) {
        setBlockError('Неуспешно зареждане на свободните часове за избраната дата.');
      } finally {
        setBlockSlotsLoading(false);
      }
    };

    loadSlotsForBlocking();
  }, [blockDate, blockMode, fetchSlotsForBarberOnDate, selectedStylist, selectedStylistComparable, showBlockModal]);

  useEffect(() => {
    if (!showBlockModal) return;
    setBlockError('');
    setBlockSuccessMessage('');
    if (blockMode === 'slots') {
      setBlockDates([]);
    } else {
      setBlockSelectedSlots([]);
    }
  }, [blockMode, showBlockModal]);

  useEffect(() => {
    if (showBlockModal && blockMode === 'slots') {
      setBlockSelectedSlots([]);
    }
  }, [blockDate, blockMode, showBlockModal]);

  const handleStylistChange = (stylistId) => {
    setSelectedStylist(stylistId);
    setSelectedTime('');
    setCurrentReservation(null);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
    setSelectedTime('');
    setMessage('');
  };

  const handleReservationClick = (slot) => {
    if (slot.available) {
      setSelectedTime(slot.time);
    } else if (isAuthenticated) {
      const reservation = reservations.find((res) => {
        const reservationDate = new Date(res.reservationDateTime).toISOString().split('T')[0];
        const isSameDate = reservationDate === selectedDate;

        const reservationTime = new Date(res.reservationDateTime).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        });
        const isSameTime = reservationTime === slot.time;
        const isSameBarber = String(res.barberId) === selectedStylistComparable;
        return (
          isSameTime &&
          isSameDate &&
          isSameBarber
        );
      });

      if (reservation) {
        setCurrentReservation(reservation);
        setShowModal(true);
      }
    }
  };

  const handleEmailChange = (event) => {
    setCustomerEmail(event.target.value);
  };

  const handleNameChange = (event) => {
    setCustomerName(event.target.value);
  };

  const handlePhoneChange = (event) => {
    setCustomerPhone(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (selectedDate && selectedService && selectedStylist && selectedTime && selectedSchedule) {
      try {
        const fullDateTime = `${selectedDate}T${selectedTime}:00`;

        const reservationData = {
          customerName,
          phoneNumber: customerPhone,
          email: customerEmail,
          reservationDateTime: fullDateTime,
          serviceId: selectedService,
          barberId: selectedStylist,
          locationId,
        };

        await axios.post('/api/reservations', reservationData, {
          headers: { 'Content-Type': 'application/json', ...(isAuthenticated ? getAuthHeaders() : {}) },
        });

        setCustomerName('');
        setCustomerEmail('');
        setCustomerPhone('');
        setSelectedTime('');

        if (isAuthenticated) {
          setConfirmationModalMessage('Успешно създадохте резервация.');
          setShowConfirmationModal(true);

          setTimeout(() => {
            requestAnimationFrame(() => {
              const modalElement = document.getElementById('confirmation-modal');
              if (modalElement) {
                customSmoothScrollToElement(modalElement);
              }
            });
          }, 0);

          fetchReservations();
        } else {
          // Страница за успешна резервация вместо модал.
          navigate('/reservation-success');
        }
      } catch (error) {
        if (error.response?.status === 401) {
          handleUnauthorized();
          return;
        }
        // Часът е зает междувременно — опресняваме календара.
        if (error.response?.status === 409) {
          setSelectedTime('');
          fetchReservations();
          setMessage(
            error.response.data?.message ||
              'Този час току-що беше зает от друг клиент. Моля, изберете друг час.'
          );
          return;
        }
        if (error.response?.status === 400 && error.response.data?.message) {
          setSelectedTime('');
          fetchReservations();
          setMessage(error.response.data.message);
          return;
        }
        console.error('Failed to create reservation', error.response?.data || error.message);
        setMessage('Неуспешен опит за резервация.');
        fetchReservations();
      }
    }
  };

  const newdate = getDefaultDate();

  const closeModal = () => {
    setShowModal(false);
    setCurrentReservation(null);
  };

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  const handleDeleteReservation = async () => {
    try {
      await axios.delete(`/api/reservations/${currentReservation.id}`, {
        headers: getAuthHeaders(),
      });
      setShowModal(false);
      setCurrentReservation(null);
      fetchReservations();
    } catch (error) {
      if (error.response?.status === 401) {
        handleUnauthorized();
        return;
      }
      console.error('Failed to delete reservation:', error);
    }
  };

  const closedDateMessage = useMemo(() => {
    if (!isClosedForSelectedDate) return null;
    if (locationId === CHERNI_VRAH_ID && selectedDateIsSunday) {
      return `В неделя ${LOCATIONS[CHERNI_VRAH_ID].name} не работи. Заповядайте в Слатина (${LOCATIONS[1].address}) — сменете локацията или изберете друг ден.`;
    }
    return 'За избраната дата няма работещи бръснари в този салон. Моля, изберете друга дата или локация.';
  }, [isClosedForSelectedDate, locationId, selectedDateIsSunday]);

  return (
    <div className="text-red-800 max-w-full flex justify-center overflow-hidden py-4">
      {isVacationMode() ? (
        <div className="flex flex-col items-center justify-center w-full px-4 py-8">
          <div className="text-center max-w-2xl">
            <h2 className="text-4xl font-bold mb-6 text-red-800">
              Alexiev's Barbershop почива
            </h2>
            <p className="text-2xl mb-4">
              до {getVacationEndDate()}
            </p>
            <p className="text-xl mb-4">
              Моля, опитайте отново след тази дата.
            </p>
          </div>
        </div>
      ) : (
        <form className="flex text-2xl flex-col items-center w-full px-4" onSubmit={handleSubmit}>
          {isOwner && (
            <div className="w-full flex justify-end px-3">
              <button
                type="button"
                onClick={openBlockModal}
                className="bg-red-800 text-neutral-100 px-4 py-2 rounded-lg shadow-md transition duration-300 hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-4 focus:ring-red-400"
              >
                Блокирай график
              </button>
            </div>
          )}
          <div className="flex py-4 flex-col gap-4 w-full px-3">
            <div className="flex flex-col gap-4 items-center w-full">
              <div className="font-bold w-full">Фризьор & Услуга:</div>
              <select
                required
                value={selectedStylist}
                onChange={(e) => handleStylistChange(e.target.value)}
                className="border w-full border-red-800 bg-neutral-100 rounded-lg p-2 transition duration-300 hover:shadow-lg focus:shadow-outline"
              >
                {sortedBarbers.map((barber) => (
                  <option key={barber.id} value={barber.id}>
                    {barber.name}
                  </option>
                ))}
              </select>

              <ServicesSelect
                services={services}
                selectedService={selectedService}
                setSelectedService={setSelectedService}
                loading={servicesLoading}
                error={servicesError}
                className="w-full"
              />

              {selectedBarber && BARBER_IMAGES[selectedBarber.name] && (
                <img
                  key={selectedBarber.id}
                  src={BARBER_IMAGES[selectedBarber.name]}
                  alt={`Бръснар ${selectedBarber.name}`}
                  className="w-40 h-40 object-cover object-top rounded-full border-2 border-red-800 shadow-lg grayscale"
                />
              )}

              {selectedBarber && selectedSchedule && (
                <p className="text-lg text-neutral-700 w-full text-center">
                  {selectedBarber.name} работи от {selectedSchedule.start} до {selectedSchedule.end} ч. на тази дата.
                </p>
              )}
            </div>
            <div className="flex gap-4 flex-col items-center w-full">
              <div className="label text-left font-bold w-full">Дата:</div>
              <input
                min={newdate}
                className="bg-neutral-100 border w-full border-red-800 rounded-lg p-2 transition duration-300 hover:shadow-lg focus:shadow-outline"
                required
                type="date"
                value={selectedDate || newdate}
                onChange={handleDateChange}
              />
              {closedDateMessage && (
                <p className="text-red-800 text-xl text-center py-4">{closedDateMessage}</p>
              )}
              <div className="label font-bold w-full">Час:</div>
              <input
                value={selectedTime || 'Не е избран'}
                className="bg-neutral-300 text-center w-full"
                disabled
              />
            </div>
          </div>
          {!isClosedForSelectedDate && (
            <div className="select-container w-full">
              {timeSlots.length > 0 ? (
                <div className="w-full flex flex-wrap gap-2 justify-center text-xl nav">
                  {timeSlots.map((slot) => (
                    <button
                      key={slot.time}
                      disabled={!slot.available && !isAuthenticated}
                      title={slot.isBreak ? 'Обедна почивка' : undefined}
                      className={`custom-option w-full sm:w-auto ${
                        selectedTime === slot.time
                          ? 'bg-red-800 bg-opacity-60'
                          : 'bg-red-800 bg-opacity-20'
                      } rounded-md p-2 hover:bg-opacity-80 transition duration-300 ${
                        !slot.available ? 'bg-gray-700 opacity-50' : ''
                      }`}
                      onClick={() => handleReservationClick(slot)}
                      type="button"
                    >
                      {slot.time}
                    </button>
                  ))}
                </div>
              ) : (
                <p className="w-full text-center">Няма налични часове за избраната дата.</p>
              )}
              {timeSlots.length > 0 && lunchBreakNote && (
                <p className="w-full text-center text-sm pt-3 opacity-80">{lunchBreakNote}</p>
              )}
            </div>
          )}
          {message && <p className="max-w-xl text-center py-4 w-full">{message}</p>}
          <div className="flex flex-col gap-2 w-full py-4 justify-between">
            <div className="font-bold">Име:</div>
            <input
              type="text"
              value={customerName}
              onChange={handleNameChange}
              className="bg-neutral-100 border w-full border-red-800 rounded-lg p-2 transition duration-300 hover:shadow-lg focus:shadow-outline"
              required
            />

            <div className="font-bold">Имейл: </div>
            <input
              type="email"
              value={customerEmail}
              onChange={handleEmailChange}
              className="bg-neutral-100 border w-full border-red-800 rounded-lg p-2 transition duration-300 hover:shadow-lg focus:shadow-outline"
              required
            />

            <div className="font-bold">Телефон:</div>
            <input
              type="tel"
              value={customerPhone}
              onChange={handlePhoneChange}
              className="bg-neutral-100 border w-full border-red-800 rounded-lg p-2 transition duration-300 hover:shadow-lg focus:shadow-outline"
              required
            />

            <button
              className="bg-red-800 text-neutral-300 w-full px-6 py-3 rounded-lg shadow-lg transform transition duration-300 hover:bg-red-700 hover:scale-105 hover:shadow-xl active:scale-95 active:bg-red-900 focus:outline-none focus:ring-4 focus:ring-red-500"
              type="submit"
              disabled={isClosedForSelectedDate}
            >
              Резервирай
            </button>
          </div>
          {showBlockModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white text-black rounded-2xl shadow-xl p-8 max-w-3xl w-full mx-4 border border-red-800">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-2xl md:text-3xl font-bold text-red-800">Блокиране на график</h3>
                  <button
                    onClick={closeBlockModal}
                    className="text-red-800 text-2xl font-bold hover:text-red-900 transition duration-200"
                  >
                    &times;
                  </button>
                </div>
                <p className="text-lg text-neutral-600 mb-4">
                  Избран бръснар: <span className="font-semibold text-red-800">{selectedBarber ? selectedBarber.name : '—'}</span>
                </p>
                <div className="flex flex-col gap-6">
                  <div className="flex flex-wrap gap-3 justify-center">
                    <button
                      type="button"
                      onClick={() => setBlockMode('slots')}
                      className={`px-4 py-2 rounded-lg font-semibold transition duration-300 ${
                        blockMode === 'slots'
                          ? 'bg-red-800 text-white shadow-lg'
                          : 'bg-red-800 bg-opacity-20 text-red-800 hover:bg-opacity-40'
                      }`}
                    >
                      Блокирай часове
                    </button>
                    <button
                      type="button"
                      onClick={() => setBlockMode('days')}
                      className={`px-4 py-2 rounded-lg font-semibold transition duration-300 ${
                        blockMode === 'days'
                          ? 'bg-red-800 text-white shadow-lg'
                          : 'bg-red-800 bg-opacity-20 text-red-800 hover:bg-opacity-40'
                      }`}
                    >
                      Блокирай дни
                    </button>
                  </div>

                  {blockError && <p className="text-red-600 text-center">{blockError}</p>}
                  {blockSuccessMessage && <p className="text-green-600 text-center">{blockSuccessMessage}</p>}

                  {blockMode === 'slots' ? (
                    <div className="flex flex-col gap-4">
                      <div className="flex flex-col sm:flex-row items-center gap-4">
                        <label className="font-bold text-left w-full sm:w-auto">Дата:</label>
                        <input
                          type="date"
                          className="bg-neutral-100 border border-red-800 rounded-lg p-2 flex-1"
                          min={newdate}
                          value={blockDate || newdate}
                          onChange={(e) => setBlockDate(e.target.value)}
                        />
                      </div>

                      {blockSlotsLoading ? (
                        <p className="text-center text-neutral-600">Зареждане на наличните часове...</p>
                      ) : blockSlots.length > 0 ? (
                        <div className="flex flex-wrap gap-2 justify-center">
                          {blockSlots.map((slot) => (
                            <button
                              key={slot.time}
                              type="button"
                              disabled={!slot.available}
                              onClick={() => handleToggleBlockSlot(slot.time)}
                              className={`px-4 py-2 rounded-md transition duration-300 ${
                                blockSelectedSlots.includes(slot.time)
                                  ? 'bg-red-800 text-white shadow-lg'
                                  : 'bg-red-800 bg-opacity-20 text-red-800 hover:bg-opacity-40'
                              } ${!slot.available ? 'bg-gray-500 text-white cursor-not-allowed hover:bg-gray-500' : ''}`}
                            >
                              {slot.time}
                            </button>
                          ))}
                        </div>
                      ) : (
                        <p className="text-center text-neutral-600">
                          Няма налични часове за избраната дата.
                        </p>
                      )}
                    </div>
                  ) : (
                    <div className="flex flex-col gap-4">
                      <div className="flex flex-col sm:flex-row items-center gap-4">
                        <label className="font-bold text-left w-full sm:w-auto">Добави дата:</label>
                        <div className="flex flex-col sm:flex-row gap-3 w-full">
                          <input
                            type="date"
                            className="bg-neutral-100 border border-red-800 rounded-lg p-2 flex-1"
                            min={newdate}
                            value={blockDateInput || newdate}
                            onChange={(e) => setBlockDateInput(e.target.value)}
                          />
                          <button
                            type="button"
                            onClick={handleAddBlockDate}
                            className="bg-red-800 text-white px-4 py-2 rounded-lg shadow-md transition duration-300 hover:bg-red-700"
                          >
                            Добави
                          </button>
                        </div>
                      </div>
                      {blockDates.length > 0 ? (
                        <div className="flex flex-wrap gap-2 justify-center">
                          {blockDates.map((date) => (
                            <div
                              key={date}
                              className="flex items-center gap-2 bg-red-800 bg-opacity-10 px-4 py-2 rounded-full"
                            >
                              <span className="text-red-800 font-semibold">{date}</span>
                              <button
                                type="button"
                                onClick={() => handleRemoveBlockDate(date)}
                                className="text-red-800 font-bold hover:text-red-900"
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="text-center text-neutral-600">Все още няма избрани дати за блокиране.</p>
                      )}
                    </div>
                  )}
                </div>

                <div className="flex justify-end gap-4 mt-8">
                  <button
                    type="button"
                    onClick={closeBlockModal}
                    className="bg-gray-400 text-white px-6 py-2 rounded-lg shadow-md hover:bg-gray-500 transition duration-300"
                  >
                    Отмени
                  </button>
                  <button
                    type="button"
                    onClick={handleBlockSubmit}
                    disabled={blockLoading}
                    className={`bg-red-800 text-white px-6 py-2 rounded-lg shadow-md transition duration-300 hover:bg-red-900 ${
                      blockLoading ? 'opacity-60 cursor-not-allowed' : ''
                    }`}
                  >
                    {blockLoading ? 'Блокиране...' : 'Блокирай'}
                  </button>
                </div>
              </div>
            </div>
          )}

          {showModal && currentReservation && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div
                id="admin-modal"
                className="bg-white text-black rounded-2xl shadow-xl p-8 max-w-md w-full border border-red-800"
              >
                <div className="flex justify-between items-center mb-6">
                  <h3 className="text-2xl font-bold text-red-800">Детайли за резервация</h3>
                  <button
                    onClick={closeModal}
                    className="text-red-800 text-2xl font-bold hover:text-red-900 transition duration-200"
                  >
                    &times;
                  </button>
                </div>
                <div className="space-y-4">
                  <p className="text-lg">
                    <strong className="text-red-800">Име:</strong> {currentReservation.customerName}
                  </p>
                  <p className="text-lg">
                    <strong className="text-red-800">Телефон:</strong> {currentReservation.phoneNumber}
                  </p>
                  <p className="text-lg">
                    <strong className="text-red-800">Имейл:</strong> {currentReservation.email}
                  </p>
                  <p className="text-lg">
                    <strong className="text-red-800">Услуга:</strong> {currentReservation.service?.name}
                  </p>
                  <p className="text-lg">
                    <strong className="text-red-800">Салон:</strong>{' '}
                    {LOCATIONS[currentReservation.locationId]?.shortName || '—'}
                  </p>
                  <p className="text-lg">
                    <strong className="text-red-800">Дата и час:</strong>{' '}
                    {new Date(currentReservation.reservationDateTime).toLocaleDateString()},{' '}
                    {new Date(currentReservation.reservationDateTime).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: false,
                    })}
                  </p>
                </div>
                <div className="flex justify-between gap-4 mt-6">
                  {isOwner && (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleDeleteReservation();
                      }}
                      className="bg-red-500 text-white px-6 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300"
                    >
                      Изтрий
                    </button>
                  )}

                  <button
                    onClick={closeModal}
                    className="bg-gray-400 text-white px-6 py-2 rounded-lg shadow-md hover:bg-gray-500 transition duration-300"
                  >
                    Затвори
                  </button>
                </div>
              </div>
            </div>
          )}

          {showConfirmationModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div
                id="confirmation-modal"
                className="bg-white text-black rounded-lg shadow-lg p-8 max-w-sm w-full"
              >
                <h3 className="text-xl font-semibold mb-4">Потвърждение</h3>
                <p>{confirmationModalMessage}</p>
                <div className="flex justify-end mt-4">
                  <button
                    onClick={closeConfirmationModal}
                    className="bg-red-800 text-white px-4 py-2 rounded-md hover:bg-red-900 transition duration-200"
                  >
                    Затвори
                  </button>
                </div>
              </div>
            </div>
          )}
        </form>
      )}
    </div>
  );
}

export default BarberShopReservation;
